import client from "apis/config";

export const getCompanyInfoApi = async (page = 1, limit = 10) => {
  return await client.get(`companyInfo?page=${page}&limit=${limit}`);
};

export const updateCompanyInfoApi = async (data) => {
  return await client.patch(`companyInfo`, data);
};
